export function splitUrlToRelativeUrl(url: string): string {
  if (!url?.trim()) {
    return '';
  }

  try {
    if (url.startsWith('http')) {
      const urlObject = new URL(url);
      return urlObject.pathname + urlObject.search + urlObject.hash;
    }

    return url;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn(`Invalid URL provided: ${url}`, error);
    return url;
  }
}

const EPI_PATH_TO_REMOVE = '/EPiServer/CMS/Content';

export function splitCmsUrlToContentPath(url: string): string {
  return url.replace(EPI_PATH_TO_REMOVE, '').split(',')[0];
}
